import React, { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import { AWS_URL } from "../../Constant";
import EmployeeMap from "./EmployeeMap";
import LocationMap from "./LocationMap";
// import "leaflet/dist/leaflet.css";



export default function HrAttendanceDashboard() {
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState("2025-09");
  const [empId, setEmpId] = useState("EMP001");

  const fetchData = useCallback(async () => {
    setLoading(true);
    const jwtToken = Cookies.get("jwt_token");

    try {
      const res = await fetch(
        `${AWS_URL}/attendance/employee/${empId}?month=${month}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );

      if (!res.ok) {
        const errText = await res.text();throw new Error(errText);
      }

      const data = await res.json();setAttendance(data);
    } catch (err) {}

    setLoading(false);
  }, [empId, month]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <div>
        <h2>Attendance for {attendance.empid}</h2>

        <EmployeeMap
          punchIn={attendance.punch_in}
          punchOut={attendance.punch_out}
        />
      </div>

      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-2xl font-bold mb-4">HR Attendance Dashboard</h2>

          {/* Filters */}
          <div className="flex gap-4 mb-4">
            <input
              type="text"
              value={empId}
              onChange={(e) => setEmpId(e.target.value)}
              placeholder="Employee Code"
              className="border rounded px-3 py-2"
            />
            <input
              type="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="border rounded px-3 py-2"
            />
            <button
              onClick={fetchData}
              className="px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600"
            >
              Fetch
            </button>
          </div>

          {/* Table */}
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="w-full border-collapse border border-gray-300">
              <thead className="bg-gray-200">
                <tr className="text-center">
                  <th className="border p-4">Date</th>
                  <th className="border p-2">Punch In</th>
                  <th className="border p-2">Punch In Image</th>
                  <th className="border p-2">Punch Out</th>
                  <th className="border p-2">Punch Out Image</th>
                  <th className="border p-2">Total Hours</th>
                  <th className="border ">Address</th>
                  <th className="border p-10">Location</th>


                </tr>
              </thead>
              <tbody>
                {attendance.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center p-4">
                      No records found
                    </td>
                  </tr>
                ) : (
                  attendance.map((record) => (
                    <tr key={record._id} className="text-center">
                      <td className="border p-2">{record.date}</td>

                      <td className="border p-2">
                        {record.punch_in?.time || "-"}
                      </td>
                      <td className="border p-2">
                        {record.punch_in_image ? (
                          <img
                            src={record.punch_in_image}
                            alt="Punch In"
                            className="w-16 h-16 object-cover mx-auto"
                          />
                        ) : (
                          "-"
                        )}
                      </td>

                      <td className="border p-2">
                        {record.punch_out?.time || "-"}
                      </td>
                      <td className="border p-2">
                        {record.punch_out_image ? (
                          <img
                            src={record.punch_out_image}
                            alt="Punch Out"
                            className="w-16 h-16 object-cover mx-auto"
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                       <td className="border p-2">{record.total_hours || 0}</td>
                      <td className="px-4 py-2 border p-2 text-blue-600 underline">
                        <a
                          href={`https://www.google.com/maps?q=${record.punch_in?.location?.lat},${record.punch_in?.location?.lng}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {record.punch_in?.location?.address || "View on Map"}
                        </a>
                      </td>
                     
                        <LocationMap
                        lat={record.punch_in?.location?.lat}
  lng={record.punch_in?.location?.lng}
  address={record.punch_in?.location?.address} />
                     
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
